export default __webpack_public_path__ + "assets/ogg/fd741b7430987b39a1b49ac63385c6da.ogg";